<template>
  <div class="prefeitura-dashboard">
    <div class="header">
      <div class="date-time">{{ formattedDate }}</div>
    </div>

    <div class="dashboard-buttons">
      <el-card>
        <h3>Ver Cemitérios</h3>
        <p>Explore os cemitérios disponíveis e veja as vagas neles.</p>
        <el-button type="primary" @click="fetchCemeteries">
          Ver Cemitérios
        </el-button>
      </el-card>
    </div>

    <!-- Cemeteries Table Filter -->
    <el-input v-model="cemeteriesFilter" placeholder="Filtrar cemitérios..." style="margin: 10px 0; max-width: 300px;" />
    <!-- Cemeteries Table -->
    <el-table
        v-if="cemeteries.length"
        :data="filteredCemeteries"
        style="margin-top: 20px; width: 100%"
        @row-click="viewVacancies"
        highlight-current-row
    >
      <el-table-column prop="name" label="Nome do Cemitério" />
      <el-table-column prop="location" label="Localização" />
    </el-table>

    <!-- Vacancies Dialog -->
    <el-dialog
        v-model:visible="showVacanciesDialog"
        title="Vagas no Cemitério"
        width="70%"
    >
      <el-input v-model="vacanciesFilter" placeholder="Filtrar vagas..." style="margin: 10px 0; max-width: 300px;" />
      <el-table
          v-if="vacancies.length"
          :data="filteredVacancies"
          style="margin-top: 20px; width: 100%"
          highlight-current-row
      >
        <el-table-column prop="quadra" label="Quadra" />
        <el-table-column prop="numeroSepultura" label="Número da Sepultura" />
        <el-table-column prop="available" label="Disponível" />
      </el-table>

      <!-- Footer Slot -->
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="showVacanciesDialog = false">Fechar</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, onMounted, computed } from "vue";

export default {
  name: "PrefeituraDashboard",
  setup() {
    const formattedDate = ref("");
    const cemeteries = ref([]);
    const vacancies = ref([]);
    const showVacanciesDialog = ref(false);
    const cemeteriesFilter = ref("");
    const vacanciesFilter = ref("");

    const filteredCemeteries = computed(() => {
      if (!cemeteriesFilter.value) return cemeteries.value;
      return cemeteries.value.filter(cem =>
        cem.name.toLowerCase().includes(cemeteriesFilter.value.toLowerCase()) ||
        cem.location.toLowerCase().includes(cemeteriesFilter.value.toLowerCase())
      );
    });

    const filteredVacancies = computed(() => {
      if (!vacanciesFilter.value) return vacancies.value;
      return vacancies.value.filter(vac =>
        (vac.quadra + " " + vac.numeroSepultura + " " + vac.available)
          .toLowerCase().includes(vacanciesFilter.value.toLowerCase())
      );
    });

    const updateDateTime = () => {
      const now = new Date();
      formattedDate.value = now
          .toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "medium" })
          .replace(",", "");
    };

    const fetchCemeteries = async () => {
      // Replace this with an actual API call
      cemeteries.value = [
        { id: "1", name: "Cemitério Central", location: "Rua das Flores, 123" },
        { id: "2", name: "Cemitério da Paz", location: "Av. Principal, 456" },
      ];
    };

    const viewVacancies = (cemetery) => {
      console.log("Viewing vacancies for:", cemetery.name);
      // Replace this with an actual API call
      vacancies.value = [
        { quadra: "A", numeroSepultura: 12, available: "Sim" },
        { quadra: "B", numeroSepultura: 8, available: "Não" },
      ];
      showVacanciesDialog.value = true;
    };

    onMounted(() => {
      updateDateTime();
      // Auto-refresh disabled for serverless compatibility
// setInterval(updateDateTime, 1000); // Update every second
      fetchCemeteries();
    });

    return {
      formattedDate,
      cemeteries,
      vacancies,
      showVacanciesDialog,
      fetchCemeteries,
      viewVacancies,
      cemeteriesFilter,
      vacanciesFilter,
      filteredCemeteries,
      filteredVacancies,
    };
  },
};
</script>

<style scoped>
.prefeitura-dashboard {
  padding: 12px 24px;
  box-sizing: border-box;
  width: 100%;
  max-width: none;
}

.header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}

.date-time {
  font-size: 16px;
  font-weight: bold;
}

.dashboard-buttons {
  margin-top: 20px;
}

.el-card {
  margin: 20px 0;
  padding: 20px;
}

.el-button {
  margin-top: 10px;
}

.dialog-footer {
  text-align: right;
}
</style>
